import { PageStatus } from "../shared/model/page-model";

export function isProcessing(pageStatus: PageStatus): boolean {
  return pageStatus === "Sending";
}
export function isErrored(pageStatus: PageStatus): boolean {
  return pageStatus === "Failed" || pageStatus === "Missing Query Parameters";
}
export function isCompleted(pageStatus: PageStatus): boolean {
  return pageStatus === "Succeeded";
}